module.exports = __webpack_public_path__ + "img/csv.ca439237.svg";